import { whyChooseUs } from "@/data/siteContent";
import useScrollReveal from "@/hooks/useScrollReveal";
import SectionHeading from "@/components/SectionHeading";

export default function WhyChooseUs() {
  const ref = useScrollReveal({ y: 50, stagger: 0.1 });
  return (
    <section
      ref={ref}
      className="border-y border-white/10 bg-[#080808]"
      data-testid="why-section"
    >
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-6 py-20 md:px-10 md:py-32 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <SectionHeading
              reveal
              eyebrow={whyChooseUs.eyebrow}
              title={whyChooseUs.heading}
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="flex flex-col">
            {whyChooseUs.reasons.map((r, i) => (
              <div
                key={r.title}
                data-reveal
                className="group border-t border-white/10 py-8 first:border-t-0 md:py-10"
                data-testid={`why-reason-${i}`}
              >
                <div className="flex items-baseline gap-6">
                  <span className="font-mono text-xs text-white/60">
                    0{i + 1}
                  </span>
                  <div>
                    <h3
                      className="font-display text-2xl text-white transition-colors md:text-3xl"
                      style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
                    >
                      {r.title}
                    </h3>
                    <p className="mt-3 max-w-xl font-body text-sm leading-relaxed text-white/55 md:text-base">
                      {r.body}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
